import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { timeout } from 'rxjs/operators';
import { ConfigService, HTTP_REQUESTS_TIMEOUT } from 'src/app/core';
import { PaymentTransportationMethod } from 'src/app/shared';

@Injectable({ providedIn: 'root' })
export class TransportationMethodService {
  constructor(private configService: ConfigService, private http: HttpClient) {}

  /**
   * Injects every transportation from API.
   */
  public getAll(): Observable<PaymentTransportationMethod[]> {
    const url = this.configService.getUrl('payment.transportationMethods');
    return this.http
      .get<PaymentTransportationMethod[]>(url, {
        withCredentials: true,
      })
      .pipe(timeout(HTTP_REQUESTS_TIMEOUT));
  }
}
